import React from 'react';
import moment from 'moment';
import { Card, Typography } from '@mui/material';
import { shortDateTimeFormat } from '../../lib/utils';

function CommentCard({
  classes,
  comment,
  user,
}) {
  return (
    <Card raised className={classes.field}>
      <div className={classes.card}>
        <Typography variant="body2">
          {comment.comment}
        </Typography>
        <div className={classes.cardFooter}>
          <Typography variant="body2" color="textSecondary">
            {user}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {moment(comment.date).format(shortDateTimeFormat)}
          </Typography>
        </div>
      </div>
    </Card>
  );
}

export default CommentCard;
